import { useEffect, useImperativeHandle, useState } from "react";
import { validateName } from "../../../../_helpers/validators";
import {
  CURRENCY_CHOICES,
  EMPLOYMENT_TYPE,
  EXPERIENCE,
  job_title_limit_length,
  JOB_FUNCTION,
  formSchema,
} from "./constants";
import { useDispatch } from "react-redux";
import {
  create_job_hiring_manager_action,
  delete_job_hiring_manager_action,
  update_job_hiring_manager_action,
  set_job_title_hiring_manager_action,
} from "../../../../redux/_actions/hiringManager";
import { useLocation, useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";

import { educationConst } from "../../../../_constants/EducationConst";
import { showWarningMessage } from "../../../../_uiComponents/ShowMessageSnack";

function useJobDetails(props, ref) {
  //initial states
  const [formData, setformData] = useState({});
  const [formInputsError, setFormInputsError] = useState({});
  const [experienceRequired, setExperienceRequired] = useState([]);
  const [employmentType, setEmploymentType] = useState([]);
  const [education, setEducation] = useState([]);
  const [jobCurrency, setJobCurrency] = useState([]);
  const [jobFunction, setJobFunction] = useState([]);
  const [loading, setloading] = useState(false);
  const [skillsTagsAdded, setSkillsTagsAdded] = useState([]);
  const [editorActiveDescription, setEditorActiveDescription] = useState(false);
  const [editorActiveRequirements, setEditorActiveRequirements] =
    useState(false);
  const [editorActiveBenefits, setEditorActiveBenefits] = useState(false);
  const [checked, setChecked] = useState(false);
  const [draftLoading, setDraftLoading] = useState(false);
  const [saveLoading, setSaveLoading] = useState(false);

  const navigate = useNavigate();
  const dispatch = useDispatch();
  const location = useLocation();

  const publishMessage = location?.msg;

  const { jobDetailsData } = useSelector(
    (state) => state.get_job_details_hiring_manager_reducer
  );

  // callbacks for parent comeponents
  useImperativeHandle(ref, () => ({
    publishForm: onPublishForm,
    submitDraft: onDraftClick,
    submitClose: onCloseJobClick,
  }));

  const onPublishForm = () => {
    return onSubmitClick("publish");
  };

  const onDraftClick = () => {
    return onSubmitClick("draft");
  };

  const onCloseJobClick = () => {
    return onSubmitClick("jobclose");
  };

  // set form data
  useEffect(() => {
    let job_id = location?.state;
    if (jobDetailsData?.data) {
      if (job_id !== null) {
        let data = jobDetailsData?.data;
        data["skills"] = data["skill_names"] && data["skill_names"];
        data["state"] = data["state_name"] && data["state_name"];
        data["city"] = data["city_name"] && data["city_name"];
        data["country"] = data["country_name"] && data["country_name"];
        data["zipcode"] = data["zipcode_code"] && data["zipcode_code"];
        data["is_remote"] = data["is_remote"] && data["is_remote"];
        setChecked(data?.is_remote);
        setJobTitleInRedux(data);
        setSkillsTagsAdded(data?.skills);
        setformData(data);
      }
    }
  }, [jobDetailsData]);
  

  //set map values for drop downs
  useEffect(() => {
    setEmploymentType(EMPLOYMENT_TYPE);
    setExperienceRequired(EXPERIENCE);
    setJobCurrency(CURRENCY_CHOICES);
    setJobFunction(JOB_FUNCTION);
    setEducation(educationConst);
  }, []);

  // get current job details
  const setJobTitleInRedux = async (data) => {
    await dispatch(set_job_title_hiring_manager_action(data));
  };

  // handle input change
  const onInputChange = (e) => {
    let value = e.target.value;
    let name = e.target.name;
    let data = formData;

    // show input errors for title
    if (name === "title") {
      let title_error = validateName(value, job_title_limit_length);
      let errors = {
        ...formInputsError,
        title: title_error,
      };
      setFormInputsError(errors);
      if (title_error.length > 0) return;
    }

    // for payment type get current input id
    if (name === "payment_type") {
      data[name] = e.target.id;
      setformData(data);
      return;
    }
    // set data values
    data[name] = value;
    setformData(data);
  };

  // count left characters in title
  const leftCharacters = (lengthSpecified, key) => {
    if (formData === undefined || formData[key] === undefined) return 64;
    else if (formData[key].length > lengthSpecified) return 0;
    return lengthSpecified - formData[key].length;
  };

  // form submit
  const onSubmitClick = async (type) => {
    let data = formData;

    // data["status"] = isDraft ? "draft" : "publish";

    //set job status
    if (type === "publish") data["status"] = "publish";
    if (type === "draft") data["status"] = "draft";
    if (type === "jobclose") data["status"] = "inactive";

    data["company_industry"] = "Computer";

    // check title for draft
    if (type === "draft") {
      setDraftLoading(true);
      if (formData["title"] === undefined || formData["title"].length === 0) {
        let errors = {
          title: "Title can not be empty",
        };
        setFormInputsError(errors);
      } else {
        // update or create jobs
        if (data?.id) {
          const res = await dispatch(
            update_job_hiring_manager_action(data, data?.id)
          );
          checkNavigate(res);
        } else {
          const res = await dispatch(create_job_hiring_manager_action(data));
          checkNavigate(res);
        }
      }
      setDraftLoading(false);
    }
    // check validate form for save forms
    else {
      setSaveLoading(true);
      if (validateForm()) {
        // update or create jobs
        if (data?.id) {
          const res = await dispatch(
            update_job_hiring_manager_action(data, data?.id)
          );
          checkNavigate(res);
        } else {
          const res = await dispatch(create_job_hiring_manager_action(data));
          checkNavigate(res);
        }
      }else showWarningMessage("Please fill all the  fields.")
    }
    setSaveLoading(false);
  };

  // check if job is created or not
  const checkNavigate = (result) => {
    if (result !== undefined) {
      navigate(-1);
    } else {
      let form_errors = {
        formSubmitError:
          result && result.msg && result.msg !== ""
            ? result.msg && result.msg
            : "Unable to create job.",
      };
      setFormInputsError(form_errors);
    }
  };

  // delete job details
  const onDeleteClick = async () => {
    if (formData?.id) {
      setloading(true);
      await dispatch(delete_job_hiring_manager_action(formData?.id));
      setloading(false);
    }
    navigate(-1);
  };

  // delete skills tags
  const onKeywordsTagsDelete = (tag) => {
    let data = formData;
    let skills = skillsTagsAdded.filter((item) => item !== tag);
    setSkillsTagsAdded(skills);
    data["skills"] = skills;
    setformData(data);
  };

  // add new skills tags
  const onKeywordsTagsAddition = (tag) => {
    let skills = skillsTagsAdded;
    if (skillsTagsAdded.indexOf(tag) === -1) {
      setSkillsTagsAdded([...skillsTagsAdded, tag]);
      skills.push(tag);
    }
    let data = formData;
    data["skills"] = skills;
    setformData(data);
  };

  // validate form inputs
  const validateForm = () => {
    let errors = {};
    let valid = { isValid: true };
    for (var key in formSchema) {
      if (key === "skills") {
        if (
          formData[key] === undefined ||
          (formData[key] && formData[key].length === 0)
        ) {
          errors[key] = `This field can not be empty.`;
          valid.isValid = false;
        }
      } else if (key !== "is_remote") {
        if (
          formData[key] === undefined ||
          formData[key] === "" ||
          formData[key] === 0 ||
          formData[key] === null
        ) {
          errors[key] = `This field can not be empty.`;
          valid.isValid = false;
        }
      }
    }

    setFormInputsError(errors);
    return valid.isValid;
  };

  const onEditorStateChange = (type) => {
    switch (type) {
      case "Description":
        setEditorActiveDescription(true);
        setEditorActiveBenefits(false);
        setEditorActiveRequirements(false);
        return;
      case "Requirements":
        setEditorActiveDescription(false);
        setEditorActiveBenefits(false);
        setEditorActiveRequirements(true);
        return;
      case "Benefits":
        setEditorActiveDescription(false);
        setEditorActiveBenefits(true);
        setEditorActiveRequirements(false);
        return;
      default:
        return;
    }
  };
  // editor get html data
  const getHtmlData = async (htmlData, key) => {
    let data = formData;
    data[key] = htmlData;
    setformData(data);
  };

  // onlocation change
  const onLocationChange = (name, value) => {
    let data = formData;

    if (name === "country") {
      data["state"] = "";
      data["city"] = "";
    }

    if (name === "state") {
      data["city"] = "";
    }

    data[name] = value;
    setformData(data);
  };

  const onRemote = () => {
    let data = formData;
    data["is_remote"] = !checked;
    setChecked(!checked);
    setformData(data);
  };

  return {
    loading,
    publishMessage,
    formData,
    formInputsError,
    employmentType,
    experienceRequired,
    jobCurrency,
    editorActiveDescription,
    editorActiveRequirements,
    editorActiveBenefits,
    jobFunction,
    education,
    checked,
    draftLoading,
    saveLoading,

    onKeywordsTagsAddition,
    onKeywordsTagsDelete,
    onDeleteClick,
    onInputChange,
    leftCharacters,
    onSubmitClick,
    onEditorStateChange,
    getHtmlData,
    onLocationChange,
    onRemote,
    skillsTagsAdded,
  };
}
export default useJobDetails;
